module.exports = __webpack_public_path__ + "img/icon-human-req.b9112d18.svg";